class YoutubeController {
  constructor() {
    this.name = 'youtube';
  }
}

export default YoutubeController;



// WEBPACK FOOTER //
// ./client/app/components/apps/youtube/youtube.controller.js